export class PortfolioBalancerReportSettings
{
    GroupByAttributeId: number | null;
    ListId: string;
    AlternativesFormId: number | null;
    Charts: ChartOptions[];
    Metrics: MetricOptions[];
    GridOptions: string;
}

export class MetricOptions
{
    MetricId: string;
    Type: string;
    Title: string;
    AttributeId?: number;
    LimitMin?: number;
    LimitMax?: number;
    IncludedStatusesIds: number[] = [];

    Decimals?: number;
    Currency: string;
    Size: string;
}

export class ChartOptions
{
    ChartId: string;
    OrderValue: number;
    Title: string;
    Size: string;
    ScatterChartOptions?: ScatterChartOptions | null;
    BalancingChartOptions?: BalancingChartOptions | null;
    BubbleChartOptions?: BubbleChartOptions | null;
}

export class BalancingChartOptions
{
    AttributeId: number | null;
    StatusesIds: number[];
    MetricType: string;
}

export class ScatterChartOptions
{
    XAxisAttributeId: number;
    YAxisAttributeId: number;
    OrderByAttributeId: number | null;
    StatusesShapes: StatusShape[];
}

export class BubbleChartOptions
{
    XAxisAttributeId: number;
    YAxisAttributeId: number;
    ZAxisOption: string;
    StatusesIds: number[];
}

export class StatusShape
{
    AlternativeStatusId: number;
    Shape: string;
}

export class ValueSource
{
    ValueSourceId: string;
    Name: string;
    OnlyBubbleSize: boolean;
}


export class BubbleChartValue
{
    AlternativeId: number;
    ValueX: number | null;
    ValueY: number | null;
    ValueZ: number | null;
}